import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '@utils/apiRequest'
import { onDownloadFile } from '@utils/download'

export const getBoardList = createAsyncThunk(
  'GET_BOARD_LIST',
  async () => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/board`,
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return response
  }
)

export const getBoardContentList = createAsyncThunk(
  'GET_BOARD_CONTENT_LIST',
  async ({boardId}) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/board/${boardId}/content`,
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return response
  }
)

export const getBoardContent = createAsyncThunk(
  'GET_BOARD_CONTENT',
  async ({contentId}) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/board/content/${contentId}`,
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return response
  }
)

export const downloadBoardAttach = createAsyncThunk(
  'DOWNLOAD_BOARD_ATTACH',
  async ({name, attachId}) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/board/attach/${attachId}`,
      responseType: 'blob',
    }
    let response = await apiRequest(options)
    if (response.__isError) {
      return
    }
    return {
      fileName: name,
      data: response,
    }
  }
)

const boardSlice = createSlice({
  name: 'board',
  initialState: {
    boardList: [],
    boardLists: {},
    boardContentList: [],
    boardContentLists: {},
  },
  reducers: {
    clearBoardList: (state) => {
      state.boardList = []
      state.boardLists = {}
    },
    clearBoardContentList: (state) => {
      state.boardContentList = []
      state.boardContentLists = {}
    },
  },
  extraReducers: {
    [getBoardList.fulfilled]: (state, { payload }) => {
      state.boardList = payload.map(data => {
        state.boardLists[data.boardId] = data
        return data.boardId
      })
    },
    [getBoardContentList.fulfilled]: (state, { payload }) => {
      state.boardContentList = payload.map(data => {
        state.boardContentLists[data.contentId] = data
        return data.contentId
      })
    },
    [getBoardContent.fulfilled]: (state, { payload }) => {
      // state.boardContentList = payload
    },
    [downloadBoardAttach.fulfilled]: (state, { payload }) => {
      if (!payload) {
        return
      }

      const url = window.URL.createObjectURL(new Blob([payload.data]))
      const fileName = payload.fileName

      onDownloadFile({url, fileName})
    },
  }
})

export const { clearBoardList, clearBoardContentList } = boardSlice.actions

export default boardSlice.reducer